module.exports = __webpack_public_path__ + "static/media/phone.b5207977.svg";